import { useLang } from '@/i18n';
import EfSection from 'elem/ui/ef-section';
import EfSpec from 'elem/ui/ef-spec';
import { useRouter } from 'next/router';
import { useProductStore } from './../../../ProductProvider';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionG');
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca', 'mx', 'br'].includes(locale);
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const { pageStatus } = useProductStore();

    const NAImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724577495374/%E9%9D%99%E9%9F%B3%20(1).jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724577495536/%E9%9D%99%E9%9F%B3%20(2).jpg',
    };
    const EUImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725000261360/eu1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725000261429/eu2.jpg',
    };
    const UKImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725000261984/uk1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725000261771/uk2.jpg',
    };
    const AUImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1736749477916/8.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1736749477464/8_M.jpg',
    };
    const PHImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751090697041/J.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751090696873/J-m.jpg',
    };

    const imgLocale: any = {
        us: NAImg,
        ca: NAImg,
        br: NAImg,
        mx: NAImg,
        uk: UKImg,
        eu: EUImg,
        de: EUImg,
        fr: EUImg,
        it: EUImg,
        es: EUImg,
        au: AUImg,
        ph: PHImg,
    };
    const imgA = imgLocale[locale] || imgLocale['eu'];
    const configs = {
        hasAnimation: false,
        title: t('title'),
        desc: t.rich('desc', {
            sup: (tx: string) => <sup>{tx}</sup>,
        }),
        pc: imgA.pc,
        h5: imgA.h5,
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection {...configs} />
            {!IS_EU_SITES && <EfSpec className="x2" />}
        </div>
    );
}
